import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/sailpoint')({
  component: SailPointComparePage,
});

function SailPointComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="sailpoint" />
    </DefaultLayout>
  );
}
